export const simulateClickUtil = (selector) => new Promise((resolve, reject) => {
    const element = document.querySelector(selector);
    if (element instanceof HTMLElement) {
        element.click();
        resolve();
    }
    else {
        reject(new Error(`Element with selector "${selector}" not found`));
    }
});
export default simulateClickUtil;
